var map = {
	"./mobile-active.svg": "7Ui1",
	"./mobile.svg": "cgRV",
	"./summary-block/first-block.svg": "ZrbV",
	"./summary-block/last-block.svg": "br7d",
	"./summary-block/middle-block.svg": "GKHI",
	"./web-active.svg": "lA9g",
	"./web.svg": "6BJS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2RX";


//////////////////
// WEBPACK FOOTER
// ./src/assets/form-ui ^\.\/.*\.svg$
// module id = g2RX
// module chunks = 46